import { useState } from 'react'
import { Youtube } from 'lucide-react'

const extractYoutubeId = (url) => {
  if (!url) return null
  const patterns = [
    /[?&]v=([^&#]+)/,
    /youtu\.be\/([^?&#]+)/,
    /youtube\.com\/embed\/([^?&#]+)/,
  ]
  for (const pattern of patterns) {
    const match = url.match(pattern)
    if (match) return match[1]
  }
  return null
}

export const YoutubeUrlEditor = ({ value, onSave, onClose }) => {
  const [url, setUrl] = useState(value || '')

  const videoId = extractYoutubeId(url)
  const thumbnailUrl = videoId
    ? `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`
    : null

  const handleSave = () => {
    onSave(url.trim())
  }

  return (
    <div className="flex flex-col gap-4">

      {/* Champ URL */}
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1.5">
          YouTube URL
        </label>
        <div className="relative">
          <Youtube size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-red-500" />
          <input
            type="url"
            value={url}
            onChange={e => setUrl(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') handleSave(); if (e.key === 'Escape') onClose() }}
            placeholder="https://www.youtube.com/watch?v=..."
            autoFocus
            className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent"
          />
        </div>
        <p className="mt-1.5 text-xs text-gray-400">
          Formats acceptés : youtube.com/watch?v=…, youtu.be/…
        </p>
      </div>

      {/* Aperçu miniature */}
      {url && (
        <div>
          <p className="text-xs font-medium text-gray-600 mb-1.5">Preview</p>
          {thumbnailUrl ? (
            <div className="relative rounded-lg overflow-hidden bg-black" style={{ paddingBottom: '56.25%' }}>
              <img
                src={thumbnailUrl}
                alt="YouTube thumbnail"
                className="absolute inset-0 w-full h-full object-cover"
              />
              {/* Icône play */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-red-600 flex items-center justify-center shadow-lg">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </div>
              </div>
            </div>
          ) : (
            <div className="flex items-center gap-2 p-3 rounded-lg bg-red-50 border border-red-200">
              <Youtube size={16} className="text-red-400 flex-shrink-0" />
              <p className="text-xs text-red-500">URL YouTube non reconnue</p>
            </div>
          )}
        </div>
      )}

      {/* Actions */}
      <div className="builder-editor-actions">
        <button
          onClick={onClose}
          className="btn btn-secondary"
        >
          Annuler
        </button>
        <button
          onClick={handleSave}
          disabled={!!url && !videoId}
          className="btn btn-primary"
        >
          Appliquer
        </button>
      </div>
    </div>
  )
}
